import { Autocomplete } from "@material-ui/lab";
import { Chip, TextField } from "@material-ui/core";

export function MultiSelect({ options, value, changeValue, ...rest }) {

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(options) => options.name}
      value={value}
      getOptionSelected={(options, value) => options._id === value._id}
      onChange={(event, newValue) => changeValue(newValue)}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="outlined"
            label={option.name}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} variant="outlined" label="Zonas" />
      )}
      {...rest}
    />
  );
}
